<template>
    <van-tabbar v-model="active" active-color="#FF9900" route class="tabbar" >
        <van-tabbar-item icon="wap-home"  to="/Index">{{ $t('system.home') }}</van-tabbar-item>
        <van-tabbar-item icon="gem"  to="/ProList">{{ $t('system.project') }}</van-tabbar-item>
        <van-tabbar-item icon="friends"  :url="$store.state.siteinfo.kefu">{{ $t('system.kefu') }}</van-tabbar-item>
        <van-tabbar-item icon="manager"  to="/Me">{{ $t('system.me') }}</van-tabbar-item>
    </van-tabbar>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {
                active: 0,
                url : ''
            };
        },
        // props:{
        //   url:{
        //       required : true,
        //       type: String,
        //   }
        // },
        mounted(){
        //    this.juplink();
        },

        methods:{
            // juplink(){
            //      this.$nextTick(function () {
            //          this.url = this.$store.state.siteinfo.kefu;
            //      })
            // }
        }
    }
</script>

<style scoped>

</style>
